import script from "./MainFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./MainFilters.vue?vue&type=script&setup=true&lang=js"

import "./MainFilters.vue?vue&type=style&index=0&id=774dd6ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-774dd6ea"]])

export default __exports__